import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { managerTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { managerMutationToasts } from '@/utils/managerMutationToasts';

const TOAST_ID = 'change-manager-pages-order';

export const changeManagerPagesOrder: managerTypes.ChangeManagerPagesOrder = (params) => {
  return axios.put(`/manager/pages/order`, params);
};

type ChangeManagerPagesOrderOptions = {
  config?: MutationConfig<typeof changeManagerPagesOrder>;
};

export function useChangeManagerPagesOrder({ config = {} }: ChangeManagerPagesOrderOptions = {}) {
  return useMutation({
    ...config,
    onMutate: (...args) => {
      managerMutationToasts.loading(TOAST_ID, 'Updating pages order...');
      config.onMutate?.(...args);
    },
    onSuccess: (...params) => {
      queryClient.invalidateQueries(['managers']);
      managerMutationToasts.success(TOAST_ID, 'Pages order updated');
      config.onSuccess?.(...params);
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      managerMutationToasts.error(TOAST_ID, serverMessage);
      config.onError?.(error, ...args);
    },
    mutationFn: changeManagerPagesOrder,
  });
}
